import React from 'react';
import cn from 'classnames';

import FiltersRefinementContentCheckbox from './SubComponents/FiltersRefinementContentCheckbox';
import FiltersRefinementContentColorData from './SubComponents/FiltersRefinementContentColorData';
import FiltersRefinementContentItem from './SubComponents/FiltersRefinementContentItem';
import FiltersRefinementContentSorting from './SubComponents/FiltersRefinementContentSorting';
import FiltersRefinementContentText from './SubComponents/FiltersRefinementContentText';
import {IFiltersRefinementContentProps} from './IFiltersRefinementContent';

import styles from './FiltersRefinementContent.module.scss';

const FiltersRefinementContent = ({children, isSublistOpen, isCollapsible}: IFiltersRefinementContentProps) => {
	return (
		<ul
			className={cn(styles['refinement-filters__content'], {
				'open' : isSublistOpen,
				[styles['refinement-filters_collapsed']] : isCollapsible
			})}
		>
			{children}
		</ul>
	);
};

FiltersRefinementContent.Color = FiltersRefinementContentItem;
FiltersRefinementContent.Checkbox = FiltersRefinementContentCheckbox;
FiltersRefinementContent.Sorting = FiltersRefinementContentSorting;
FiltersRefinementContent.Text = FiltersRefinementContentText;
FiltersRefinementContent.Item = FiltersRefinementContentItem;
FiltersRefinementContent.ColorData = FiltersRefinementContentColorData;

export default FiltersRefinementContent;